import { render, staticRenderFns } from "./ThreadDiscussion.vue?vue&type=template&id=0ad81d39"
import script from "./ThreadDiscussion.vue?vue&type=script&lang=js"
export * from "./ThreadDiscussion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports